import envHandler from '@lima/env-handler';
import { BackTop, Popover, Tooltip } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { axios_ } from "../../tools/axios_";
import sensors from '../../tools/sensors/autoTrack';
import { Utils } from '../../tools/utils';
import './footTool.less';

function mapStateToProps(state) {
  return {
    token: state.token
  }
}



class FootTool extends Component {
  constructor(props){
    super(props)
    this.state={
      qrUrl:'',
    };
  }

  componentDidMount(){
    axios_({
      url:'/openapi/wechat/qrbind/get',
      method:'get',
      headers:{'Authorization':this.props.token}
    }).then(res=>{
      if(res.data && res.data.code === 10000){
        this.setState({
          qrUrl:res.data.data
        })
      }
    }).catch(err=>console.log(err));
    // todo: 后续可在 envHandler 中暴露 function enabledAtProd(callBack: ()=> undefined, forceInspectKey: string)
    if(envHandler.isProd()){
      Utils.insertKefu()
    }
  }

  setUrlComponent = ()=>{
    return(
      <div className="foot_tool_box_wechart">
        <div className="wechart_qrcode">
          <img src={this.state.qrUrl} alt=""/>
        </div>
        <p>微信扫码并关注</p>
        <p>"保保云服务"公众号</p>
        <p className="desc">即可收到推送的通知</p>
      </div>
    )
  };


  render() {
    return (
      <div className="foot_tool" style={{'bottom': '30%' }}>
        {
            !Utils.isHLB() && <React.Fragment>
                <Tooltip placement="left" title={"在线客服"}>
                    <div className="tool_btn service" onClick={()=>{
                      const path = window.location.hash;
                      let source = '';
                      if (path.includes('#/homePage')) {
                        source = '首页';
                      } else if (path.includes('#/orgnization/orgnizationList')) {
                        source = '组织结构-升级版';
                      } else if (path.includes('#/productSys/feeTemplate/detail') || path.includes('#/productSys/commission/template')) {
                        source = '模板配置-模板详情';
                      } else if (path.includes('#/productSys/feeTemplate')) {
                        source = '推广费配置-模板配置';
                      } else if (path.includes('#/settlement/myIncome')) {
                        source = '我的收入';
                      }
                      sensors.track('MerchantServiceClick', {
                        "source": source,
                      });
                      window.qimoChatClick()
                    }}> </div>
                    <div className="tool_text" style={{'display': 'flex','justifyContent': 'center'}}>联<br/>系<br/>我<br/>们</div>
                </Tooltip>
                {
                    // 微信公众号
                    !(this.props.pageConfig && this.props.pageConfig.weChartClose) &&
                    <Popover placement="leftBottom" content={this.setUrlComponent()} title="" trigger="hover">
                        <div className="tool_btn wechart"> </div>
                        <div className="tool_text" style={{'display': 'flex','justifyContent': 'center'}}>微<br/>信<br/>公<br/>众<br/>号</div>
                    </Popover>
                }
            </React.Fragment>
        }
        <Tooltip placement="left" title={"回到顶部"}>
          <BackTop className="my-backtop"/>
        </Tooltip>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
)(FootTool);
